import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {StateService} from './state.service';

@NgModule({
    declarations: [],
    providers: [StateService],
    imports: [CommonModule],
})
export class StateModule {}
